// src/App.js
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { FlexContainer, LoadingSpinner, LoadingContainer}  from './styled/common'; // Ensure this is correctly imported
import AppRouter from "./components/AppRouter";
import Navigation from "./components/Navigation/Navigation";
import authService from "./services/authService";
import styled from 'styled-components';


const MainContent = styled.div`
  padding: 20px;

  @media (min-width: 768px) {
    margin-left: 200px; /* shifts only on desktop */
  }
`;

const App = () => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const validateUserToken = async () => {
      try {
        const authenticatedUser = await authService.validateToken();
        if (authenticatedUser) {
          setUser(authenticatedUser);
        } else {
          console.error("User not authenticated");
        }
      } catch (error) {
        console.error("Validation failed:", error);
      } finally {
        setIsLoading(false);
      }
    };
    validateUserToken();
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    setUser(null);
    window.location.href = "/";
  };

  if (isLoading) {
    return (
      <LoadingContainer>
        <LoadingSpinner />
      </LoadingContainer>
    );
  }

  return (
    <Router>
      <FlexContainer direction="row" justify="center">
        {user && <Navigation user={user} onLogout={handleLogout} />}
        <MainContent>
          <AppRouter user={user} onLogin={handleLogin} />
        </MainContent>
      </FlexContainer>
    </Router>
  );
};

export default App;
